export const ARTING_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.arting.ai'

export function useArtingPromo() {
  const until = useCookie('arting_promo_until', { default: () => 0, maxAge: 86400, sameSite: 'lax', path: '/' })
  // Preserve the server snapshot during hydration, including prerendered HTML.
  // app.html hides a previously dismissed banner before the client mounts.
  const initialUntil = useState('arting-header-initial-until', () => Number(until.value || 0))
  const hydrated = useState('arting-promo-hydrated', () => false)
  const resultDismissed = useState('arting-result-dismissed', () => false)
  const now = ref(Date.now())
  const { t } = useI18n()
  const copy = computed(() => Object.fromEntries(
    ["abilities","header","mobile","footer","title","description","download","scan","qr","close","closeQr"].map(key => [key, t(`artingPromo.${key}`)]),
  ))
  const headerVisible = computed(() => Number((hydrated.value ? until.value : initialUntil.value) || 0) <= now.value)
  let timer
  onMounted(() => {
    hydrated.value = true
    try { resultDismissed.value = sessionStorage.getItem('arting_result_dismissed') === '1' } catch {}
    const refresh = () => { now.value = Date.now() }
    timer = window.setInterval(refresh, 60000)
    refresh()
  })
  onBeforeUnmount(() => clearInterval(timer))
  function dismissHeader() {
    until.value = Date.now() + 86400000
    document.documentElement.setAttribute('data-arting-dismissed', '1')
  }
  function dismissResult() {
    resultDismissed.value = true
    try { sessionStorage.setItem('arting_result_dismissed', '1') } catch {}
  }
  watch(headerVisible, value => {
    if (import.meta.client && value) document.documentElement.removeAttribute('data-arting-dismissed')
  })
  return { copy, headerVisible, resultDismissed, dismissHeader, dismissResult }
}
